import Vue from "vue";
import { mapGetters } from "vuex";
import simplebar from "simplebar-vue";
import {
    OrderSummaryTitle,
    OrderSummaryProducts,
    OrderSummaryPlasticBag,
    OrderSummaryShippingCost,
    OrderSummaryEntregaZero,
    OrderSummaryShippingInfo,
    OrderSummaryPromotionsInfo
} from "./checkout/orderSummaryGeneral";
import {
    OrderSummaryTotal,
    OrderSummaryRetention,
    OrderSummaryTotalWithoutRetention,
    OrderSummaryPoupa,
    OrderSummaryAcumula,
    OrderSummaryContinueButton,
    OrderSummaryPlaceOrderButton
} from "./checkout/orderSummaryTotals";
import { REVIEW_STEP } from "../../utilities/constants";

const OrderSummaryComponent = Vue.extend({
    template: /*html*/ `
        <div>
            <div id="cart-summary" class="ct-cart--summary-wrapper pt-0 pt-md-4">
                <div id="js-cart-summary-container">
                    <div id="cart-summary-drag" class="summary-header d-md-none">
                    </div>
                </div>
                <div class="ct-cart--summary-section mt-2 mt-md-0">
                    <div class="ct-cart--sumary-section-container mt-0">
                        <div :class="['ct-cart--mobile-entrega-zero', resources.isEntregaZero ? 'd-none' : 'd-block d-sm-none']" v-if="resources.authenticatedCustomer">
                            <order-summary-entrega-zero
                                :resources="resources"
                                :icon="entregaZeroIcon" />
                        </div>
                        <div :class="['ct-cart--summary-details no-gutters d-md-block', resources.shipping.length > 1 ? 'split-shipping-summary-wrapper' : '']">
                            <order-summary-title
                                :resources="resources" />
                            
                            <div class="ct-cart--summary-details-container" id="summary-section-simplebar">
                                <div class="d-sm-flex d-md-block flex-sm-wrap flex-md-nowrap no-gutters my-1">       
                                    <order-summary-shipping-info
                                        v-for="(item, index) in resources.shipping"
                                        :key="item.UUID"
                                        :resources="resources"
                                        :item="item"
                                        :index="index"
                                        :multishipping="resources.shipping.length > 1"
                                        :questionmarkicon="questionMarkIcon"
                                        :iconEntregaZero="entregaZeroIcon" />

                                    <hr class="w-100 ct-cart--summary-multishipping-splitter"
                                        v-if="resources.shipping.length > 1"/>

                                    <order-summary-promotions-info
                                        :resources="resources"
                                        :multishipping="resources.shipping.length > 1"/>
                                </div>
                            </div>
                            <div class="ct-cart--discount-area css-mobile-summary flex-wrap flex-sm-nowrap mt-4">
                                <order-summary-poupa :resources="resources" />
                                <order-summary-acumula :resources="resources" />
                            </div>

                            <order-summary-total-without-retention
                                v-if="currentStep == REVIEW_STEP && resources.totals && resources.totals.grandTotalExcludeNonFinancialAndRetention"
                                :resources="resources" />
                            
                        </div>
                    </div>
                </div>

                <order-summary-retention
                    v-if="currentStep == REVIEW_STEP && resources.totals && resources.totals.retentionValue"
                    :resources="resources"                         
                    :questionmarkicon="questionMarkIcon" />

                <div class="ct-cart--subtotal-section mt-2 mt-md-4">
                    <order-summary-total
                        :resources="resources"
                        :currentStep="currentStep"
                        :entregazeroicon="entregaZeroIcon" />

                    <div class="ct-cart--discount-area d-none d-md-block mb-md-3">
                        <order-summary-poupa :resources="resources" />
                        <order-summary-acumula :resources="resources" />
                    </div>
                </div>

                <order-summary-continue-button
                    v-show="!this.getOrderReviewPageBoolean()"
                    :resources="resources"
                    :currentStep="currentStep" />

                <order-summary-place-order-button
                    v-show="this.getOrderReviewPageBoolean()"
                    :resources="resources" />
            </div>
        </div>`,
    computed: {
        ...mapGetters(["getOrderReviewPageBoolean"])
    },
    data() {
        return {
            REVIEW_STEP
        };
    },
    components: {
        OrderSummaryTitle,
        OrderSummaryProducts,
        OrderSummaryPlasticBag,
        OrderSummaryShippingCost,
        OrderSummaryEntregaZero,
        OrderSummaryRetention,
        OrderSummaryTotalWithoutRetention,
        OrderSummaryTotal,
        OrderSummaryPoupa,
        OrderSummaryAcumula,
        OrderSummaryContinueButton,
        OrderSummaryPlaceOrderButton,
        OrderSummaryShippingInfo,
        OrderSummaryPromotionsInfo,
        simplebar
    }
});

export default OrderSummaryComponent;
